<template>
    <v-dialog
      v-model="uploaddialog"
      width="500"
    >
    <template v-slot:activator="{ on }">
        <v-btn v-on="on" depressed color="primary">Upload Documents</v-btn>
      </template>
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Upload Documents
        </v-card-title>

        <v-card-text>
           <v-form
    ref="form"
    v-model="valid"
  >
            <v-select
            v-model='selectedDocumentType'
            required
             accept="image/png, image/jpeg, image/bmp"
            :rules="[v => !!v || 'Item is required']"
          :items="items"
          label="Document Type"
          
        ></v-select>
           <v-file-input v-model='theFile' required :rules="[
        value => !!value  || 'Please Select a file']" @change='convertoBase64' label="File input"></v-file-input>
           </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          :disabled="!valid"
            color="primary"
            text
            @click="uploadDoc()"
          >
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
import { postReq} from '../../../helper/firestore'
import { mapFields } from 'vuex-map-fields';
export default {
  props : {
    uid : String
  },
    data() {
        return {
          valid : true,
          selectedDocumentType : null,
            uploaddialog : false,
            theFile : null,
             items: ['Pedigree', 'Lab Results', 'Pathology Reports','Imaging','Other Reports'],
        }
    },
        computed : {
    ...mapFields([
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    },
    methods : {
              convertoBase64(f){
             if (f === null){return;}
          var reader = new FileReader();
          reader.onload = ((theFile) => {
            this.theFile = theFile;
            return (e) => {
              var binaryData = e.target.result;
              this.PedigreeUploadFile = window.btoa(binaryData);
            };
          })(f);
          reader.readAsBinaryString(f);
      },
         uploadDoc(){
           if(!this.$refs.form.validate()){
             return;
           }
          postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/uploadFile',
          {
          uid: this.uid,
          baseString : this.PedigreeUploadFile,
          selectedDocType : this.selectedDocumentType,
          fileType : this.theFile.type, 
          fileName : this.theFile.name}, result=>{
          this.uploaddialog = false
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = result.data
          this.theFile = null;
          this.selectedDocumentType = null;
          setTimeout(()=>{ this.$emit('uploadcomplete') }, 3000);
          
          }
         )
        this.uploaddialog = false
      },
    }
}
</script>

<style>

</style>